import React from 'react';
import { Outlet } from 'react-router-dom';
import DomainUserNav from '../navigation/DomainUserNav';

const DomainUserLayout: React.FC = () => {
  return (
    <div>
      <DomainUserNav />
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default DomainUserLayout;